import { useEffect } from "react";

const BASE_TITLE = "UTM Builder - My AI Labs";

export const usePageTitle = (pageTitle) => {
  useEffect(() => {
    if (pageTitle) {
      document.title = `${pageTitle} | ${BASE_TITLE}`;
    } else {
      document.title = BASE_TITLE;
    }
    
    return () => {
      document.title = BASE_TITLE;
    };
  }, [pageTitle]);
};

export default usePageTitle;
